import { FetchApiClient, noToken } from "@core/ports/http";

import { authApi } from "@apis/account/api";

import { env } from "./env.ts";

export const API = {
  auth: new FetchApiClient({
    api: authApi,
    getToken: noToken,
    stage: env.STAGE,
  }).getApi(),
} as const;
